const isEnabled = (value) => {
    return ['1', 'true', 'yes', 'on'].includes(String(value || '').trim().toLowerCase());
};

export const getGoogleAuthConfig = (
    runtimeConfig = typeof window !== 'undefined' ? window.__PINNHUB_CONFIG__ : undefined,
    buildConfig = null,
) => {
    const runtime = runtimeConfig && typeof runtimeConfig === 'object' ? runtimeConfig : {};
    const build = buildConfig === null ? {
        REACT_APP_GOOGLE_AUTH_ENABLED: process.env.REACT_APP_GOOGLE_AUTH_ENABLED,
        REACT_APP_GOOGLE_LOGIN_ONLY: process.env.REACT_APP_GOOGLE_LOGIN_ONLY,
    } : buildConfig;
    const hasRuntimeValue = (key) => Object.prototype.hasOwnProperty.call(runtime, key);
    const googleLoginOnly = hasRuntimeValue('googleLoginOnly')
        ? isEnabled(runtime.googleLoginOnly)
        : isEnabled(build.REACT_APP_GOOGLE_LOGIN_ONLY);
    const googleAuthEnabled = googleLoginOnly || (
        hasRuntimeValue('googleAuthEnabled')
            ? isEnabled(runtime.googleAuthEnabled)
            : isEnabled(build.REACT_APP_GOOGLE_AUTH_ENABLED)
    );

    return { googleAuthEnabled, googleLoginOnly };
};

export const getForceLoginEnabled = (
    runtimeConfig = typeof window !== 'undefined' ? window.__PINNHUB_CONFIG__ : undefined,
    buildConfig = null,
) => {
    const runtime = runtimeConfig && typeof runtimeConfig === 'object' ? runtimeConfig : {};
    const build = buildConfig === null
        ? { REACT_APP_FORCE_LOGIN_ENABLED: process.env.REACT_APP_FORCE_LOGIN_ENABLED }
        : buildConfig;
    return Object.prototype.hasOwnProperty.call(runtime, 'forceLoginEnabled')
        ? isEnabled(runtime.forceLoginEnabled)
        : isEnabled(build.REACT_APP_FORCE_LOGIN_ENABLED);
};

export const getAuthCookieSessionsEnabled = (
    runtimeConfig = typeof window !== 'undefined' ? window.__PINNHUB_CONFIG__ : undefined,
    buildConfig = null,
) => {
    const runtime = runtimeConfig && typeof runtimeConfig === 'object' ? runtimeConfig : {};
    const build = buildConfig === null
        ? { REACT_APP_AUTH_COOKIE_SESSIONS_ENABLED: process.env.REACT_APP_AUTH_COOKIE_SESSIONS_ENABLED }
        : buildConfig;
    return Object.prototype.hasOwnProperty.call(runtime, 'authCookieSessionsEnabled')
        ? isEnabled(runtime.authCookieSessionsEnabled)
        : isEnabled(build.REACT_APP_AUTH_COOKIE_SESSIONS_ENABLED);
};
